import FaqMySites from '@/components/FrequentlyQuestions/FaqMySites';
import { TrialActiveBannerInSites } from '@/pages/sites/components/TrialActiveBannerInSites';
import { TitanUpgradeBottomAdvertisementHandler } from '@/pages/titanAdvertisement/TitanUpgradeBottomAdvertisementHandler/';
import { TitanUpgradeToastHandler } from '@/pages/titanAdvertisement/TitanUpgradeToastHandler';
import {
  domainsActions, logoBuilderActions, productsActions, sitesActions,
} from '@/redux/modules';
import React, {
  useCallback,
  useEffect,
  useState,
  createRef,
} from 'react';
import { withI18n } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  useHistory,
} from 'react-router-dom';
import { sitesPagesLocale } from './SitesHandler.locale';
import * as Styles from './SitesHandler.styles';
import { EmptyList } from '../components/EmptyList';
import { sitesHandlerGa } from '@/utils/ThirdParties/tagManager';
import { sitesAnalytics } from '@/analytics';
import useLocale from '@/hooks/useLocale';
import { useMountNotificationModal } from '@/hooks/sites/sitesList/useMountNotificationModal';
import { useMountEmptyList } from '@/hooks/sites/sitesList/useMountEmptyList';
import { useCardActions } from '@/hooks/sites/sitesList/useCardActions';
import { useCostumerPortalSurvey } from '@/hooks/surveys/useCostumerPortalSurvey';
import { FloatingSurvey } from '@/pages/FloatingSurvey';
import { SitesHandlerModals } from '../components/SitesHandlerModals';
import PageMessages from '@/pages/common/PageMessages';
import {
  Accordion,
  Button,
  PageTitle,
  Banner,
} from 'gatorcomponents';
import {
  checklistProgressStatus, modalCloseAction, steps,
} from './SitesHandler.enum';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { DiscountSaversBanner } from '@/components/billing';
import { DiscountOfferBanner } from '@/components/billing/subscriptions/DiscountOfferBanner';
import { DiscountType } from '@/components/billing/subscriptions/PaymentModal/PaymentModal.types';
import {
  AI_AGENTS_SITES_PAGE_BANNER,
  ATIVACAO_CHANGE_DOMAIN_FLOW,
  ATIVACAO_CHANGE_SITES_CREATE_BANNER,
  ENABLE_LOGO_BUILDER,
  FOXTROT_ECOMMERCE_PLUS_MODAL_TO_WIZARD,
  XRAY_ENABLED_DISCOUNT_OFFER_BANNER,
  XRAY_ENABLED_DISCOUNT_SAVERS,
  XRAY_ENABLED_WELCOME_CHECKLIST,
} from '@/config/GrowthBook/constants';
import { STATUS_TYPE } from '@/enums/sites/status.enum';
import { ModalAutoSSL } from '../components/ModalAutoSSL';
import { ModalAutoSslTypes } from '../components/ModalAutoSSL/ModalAutoSSL.types';
import { MODAL_TYPE } from '@/hooks/sites/sitesList/useMountNotificationModal/useMountNotificationModal.enum';
import { useResize } from '@/hooks/useResize';
import { GroupedCards } from '../components/GroupedCards';
import { getURLCpanel } from '@/config/urls/cpanelUrls';
import { useCardActionsLocale } from '@/hooks/sites/sitesList/useCardActions/useCardActions.locale';
import { IconDetailedOtherSquare, IconDetailedSiteBuilder, IconDetailedWordpress } from '@/icons';
import { DomainsAlerts } from '../components/DomainsAlerts';
import logger from '@/utils/logger';
import { WelcomeCheckListBanner } from '../components/WelcomeCheckListBanner';
import { WHMCS_URL } from '@/config';
import { useBlockedWindowModal } from '@/hooks/useBlockedWindowModal';
import { LogoBuilder } from './components/LogoBuilder';
import { LogoBuilderSuccessModal } from '@/pages/LogoBuilder/components';
import { TempDomainModal } from '@/pages/Products/TempDomainModal';
import { ChangeDomainBlockModal } from '@/pages/Products/ChangeDomainBlockModal';
import { Popover } from '@/components/Popover';
import { PopoverContent } from '@/components/Popover/PopoverContent';
import { StudioAdBanner } from '@/pages/Studio/components/StudioAdBanner';
import { studioAnalytics } from '@/analytics/studio';
import { ModalBlockedPopup } from '@/hooks/useBlockedWindowModal/components/ModalBlockedPopup';
import { POPUP_BLOCKED_ORIGIN } from '@/hooks/useBlockedWindowModal/useBlockedWindowModal.enum';

let filterTimeout = null;
const SitesHandler = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const sites = useSelector(state => state.sites.list);
  const diagnostic = useSelector(state => state.preChat);
  const propagationStatus = useSelector(state => state.newDomains.propagationStatus);
  const [filteredSitesItems, setFilteredSitesItems] = useState(sites);
  const [blockedWindowUrl, setBlockedWindowUrl] = useState('');
  const [blockedPopupOrigin, setBlockedPopupOrigin] = useState(null);

  const {
    renderBlockedWindowModal,
    removePopupBlockedModalFromCookie,
    setPopupBlockedModalOnCookie,
    popupBlocked,
  } = useBlockedWindowModal();

  const products = useSelector(state => state.products);
  const loadedSites = useSelector(state => state.sites.loadedSites);
  const { allDomainsDnsStatus } = useSelector(state => state.sites);
  const loadingExclusion = useSelector(state => state.sites.loadingExclusion);
  const loadingRedirect = useSelector(state => state.sites.loadingRedirect);
  const loadingCPanelSSO = useSelector(state => state.products.cPanelLoading);
  const {
    available: logoBuilderAvailable, loading: logoBuilderLoading, buildingLogo, clickOnMenu: clickOnLogoBuilderMenu,
  } = useSelector(state => state.logoBuilder);
  const { routes, sites: sitesLocale } = useLocale();
  const enabledDiscountOfferBanner = useFeatureIsOn(XRAY_ENABLED_DISCOUNT_OFFER_BANNER);
  const changeDomainFlow = useFeatureIsOn(ATIVACAO_CHANGE_DOMAIN_FLOW);
  const enabledDiscountSaversBanner = useFeatureIsOn(XRAY_ENABLED_DISCOUNT_SAVERS);
  const enabledEcommercePlusModalToWizard = useFeatureIsOn(FOXTROT_ECOMMERCE_PLUS_MODAL_TO_WIZARD);
  const enableLogoBuilder = useFeatureIsOn(ENABLE_LOGO_BUILDER);
  const onboardingReenterBanner = useFeatureIsOn(ATIVACAO_CHANGE_SITES_CREATE_BANNER);

  const allEmails = useSelector(state => state.emails.proEmailList);
  const [shouldRenderToast, setShouldRenderToast] = useState(false);
  const [shouldRenderBottomBanner, setShouldRenderBottomBanner] = useState(false);
  const [bottomBannerVariant, setBottomBannerVariant] = useState('dark');
  const [advertisementType, setAdvertisementType] = useState('');
  const [showDnsInProgressModal, setShowDnsInProgressModal] = useState(false);
  const [dnsInProgressDomain, setDnsInProgressDomain] = useState('');
  const [shouldRenderNotificationModal, setShouldRenderNotificationModal] = useState(false);
  const [shouldRenderConfigureDomainModal, setShouldRenderConfigureDomainModal] = useState(false);
  const [modalWarningType, setModalWarningType] = useState('');
  const [modalDomains, setModalDomains] = useState([]);
  const [domainToConfigureSSL, setDomainToConfigureSSL] = useState({ domain: '', hostingId: 0 });
  const [sslModalInitialStep] = useState(ModalAutoSslTypes.steps.SSL_AUTO_SSL_ACTIVATION);
  const windowRect = useResize();
  const { width } = windowRect;
  const mobile = width < 600;
  const enabledWelcomeChecklist = useFeatureIsOn(XRAY_ENABLED_WELCOME_CHECKLIST) && !mobile;
  const enabledNewSiteModal = !enabledWelcomeChecklist;
  const [groupedCards, setGroupedCards] = useState([]);
  const domains = useSelector(state => state.newDomains);
  const [hostingId, setHostingId] = useState(null);
  const [domainsPage, setDomainsPage] = useState(1);
  const [justUpdatedDomains, setJustUpdatedDomains] = useState(false);

  const [temporaryDomainModal, setTemporaryDomainModal] = useState([]);
  const [temporaryDomainModalOption, setTemporaryDomainModalOption] = useState(null);

  const [changeDomainBlockModal, setChangeDomainBlockModal] = useState(false);

  const [hasAbleSiteToConfigure, setAbleSiteToConfigure] = useState(false);
  const summary = useSelector(state => state.summary);
  const { welcomeCheckListSteps } = useSelector(state => state.sites);
  const { isIframeOpen } = useSelector(state => state.merlin);
  const [welcomeChecklistCardData, setWelcomeChecklistCardData] = useState(null);
  const [listCheckedsLoaded, setListCheckedsLoaded] = useState([]);
  const [loadedWelcomeChecklistCardData, setLoadedWelcomeChecklistCardData] = useState(false);
  const [showLogoBuilder, setShowLogoBuilder] = useState(true);
  const [showLogoBuilderSuccessModal, setShowLogoBuilderSuccessModal] = useState(false);
  const guideRef = createRef(null);
  const [guidePosition, setGuidePosition] = useState({ left: null, top: null });
  const showAIAgentButton = useFeatureIsOn(AI_AGENTS_SITES_PAGE_BANNER);
  const {
    sitesWarningModal: sitesWarningModalAnalytics,
    ecommercePlusModal: ecommercePlusModalAnalytics,
    welcomeChecklistBanner: welcomeChecklistBannerAnalytics,
  } = sitesAnalytics;

  const handleShowTempDomainModal = useCallback(({ temporaryDomains, label }) => {
    setTemporaryDomainModal(temporaryDomains);
    setTemporaryDomainModalOption(label);
  }, []);


  const generateListChecksLoaded = useCallback(() => {
    if (enabledWelcomeChecklist && welcomeChecklistCardData !== null) {
      welcomeChecklistCardData.map((item) => {
        if (item.completion_date && item.completion_date !== null && !listCheckedsLoaded.includes(item.step)) {
          listCheckedsLoaded.push(item.step);
        }
        return null;
      });
      setListCheckedsLoaded(listCheckedsLoaded);
    }
  }, [welcomeChecklistCardData, listCheckedsLoaded, setListCheckedsLoaded, enabledWelcomeChecklist]);

  const keyLogoBuilderBanner = localStorage.getItem('viewedLogoBuilderBanner');
  const viewedLogoBuilderBanner = keyLogoBuilderBanner === 'true';

  const handleLogoBuilderBanner = () => {
    setShowLogoBuilder(false);
    localStorage.setItem('viewedLogoBuilderBanner', 'true');
  };

  const verifyWelcomeCheckListInProgress = useCallback(() => {
    if (enabledWelcomeChecklist) {
      dispatch(sitesActions.welcomeChecklist.request({ clientId: summary.id, action: setLoadedWelcomeChecklistCardData }));
    }
  }, [dispatch, enabledWelcomeChecklist, summary.id]);

  const listHostingId = [];

  const hasWelcomeChecklistInProcess = () => {
    if (welcomeCheckListSteps.data.length === 0) {
      return false;
    }
    if (welcomeCheckListSteps.data.length === checklistProgressStatus.completed && welcomeCheckListSteps.data[3].step === steps.finishStep) {
      listHostingId.push(welcomeCheckListSteps.data[0].hosting_id);
      return false;
    }

    if (welcomeCheckListSteps.data.length > checklistProgressStatus.noStarted && welcomeCheckListSteps.data.length < checklistProgressStatus.completed) {
      setWelcomeChecklistCardData(welcomeCheckListSteps.data);
      return true;
    }

    if (welcomeCheckListSteps.data.length > checklistProgressStatus.completed) {
      welcomeCheckListSteps.data.filter(hosting => hosting.step === steps.finishStep)
        .forEach(hosting => listHostingId.push(hosting.hosting_id));
      const hostingsInProgress = welcomeCheckListSteps.data.filter(hosting => !listHostingId.includes(hosting.hosting_id));
      if (hostingsInProgress.length > 0) {
        setWelcomeChecklistCardData(hostingsInProgress);
        setHostingId(hostingsInProgress[0].hosting_id);
        return true;
      }
      return false;
    }

    return true;
  };

  const startWelcomeChecklistProcess = useCallback(() => {
    if (!hasWelcomeChecklistInProcess()) {
      const sitesEnabled = sites.filter(site => site.show_new_site_warning === true && site.status_plan === 'active' && !listHostingId.includes(site.external_id));
      if (sitesEnabled.length > 0) {
        const externalId = sitesEnabled[0].external_id;

        setHostingId(externalId);
        setAbleSiteToConfigure(true);

        const data = {
          clientId: summary.id,
          hostingId: externalId,
          step: 1,
          check: false,
        };

        dispatch(sitesActions.upateStepWelcomeChecklist.request(data));
      }
    } else {
      !hostingId && setHostingId(welcomeCheckListSteps.data[0].hosting_id);
      const hostingsInProgress = welcomeCheckListSteps.data.filter(hosting => !listHostingId.includes(hosting.hosting_id));

      if (hostingsInProgress.length > 3 && hostingsInProgress[3].step === steps.finishStep) {
        setAbleSiteToConfigure(false);
      } else {
        setAbleSiteToConfigure(true);
      }
    }
  }, [sites, dispatch, summary.id, welcomeCheckListSteps]);

  useEffect(() => {
    verifyWelcomeCheckListInProgress();
  }, [verifyWelcomeCheckListInProgress]);

  useEffect(() => {
    generateListChecksLoaded();
  }, [generateListChecksLoaded]);

  useEffect(() => {
    loadedWelcomeChecklistCardData && startWelcomeChecklistProcess();
  }, [startWelcomeChecklistProcess, loadedWelcomeChecklistCardData]);

  const {
    eligibleForTitanUpgrade,
    eligibleDomainOptions,
  } = useSelector(state => state.emails);

  const [displayModalTitanAdvertisementHandler, setDisplayModalTitanAdvertisementHandler] = useState(false);
  const [linkOptions, setLinkOptions] = useState([]);

  const domainWithoutEmail = allEmails.filter(item => item.type === 'domain' && !!item.domain && item.status === 'Active');
  const openInNewTabClick = url => window.open(url, '_blank').focus();
  const { mountEmptyOptions } = useMountEmptyList(products.owned);
  const openWordpressLink = domain => openInNewTabClick(`https://${domain}/wp-admin`);

  const popoverStorageKey = 'notShowSitesBannerPopover';
  const notShowBannerPopover = localStorage.getItem(popoverStorageKey) || isIframeOpen;

  const {
    survey,
    handleFinishSurvey,
    surveyQuestionsAnswered,
    setSurveyQuestionsAnswered,
    shouldRenderSurvey,
    shouldRenderOpened,
    handleSendQuestion,
    handleStartSurvey,
    handleClose,
    handleJumpQuestion,
  } = useCostumerPortalSurvey();

  const {
    filterCards,
    mountDescription,
    getDropdownActions,
    getMainActions,
    siteInExclusion,
    setSiteInExclusion,
    filteredOptions,
    setFilteredOptions,
    filterTyped,
    setFilterTyped,
    clearFilter,
    button,
    displayCreateSiteBanner,
    filterCanceledSites,
    groupByExternalId,
    loadingCpanelSSOProductId,
    setLoadingCpanelSSOProductId,
  } = useCardActions({
    history,
    loadingExclusion,
    loadingCPanelSSO,
    routesLocale: routes,
    allDomainsDnsStatus,
    setShowDnsInProgressModal,
    openWordpressLink,
    setDnsInProgressDomain,
  });

  const groupCards = useCallback(() => {
    if (filteredSitesItems && filteredSitesItems.length) {
      const group = groupByExternalId(filteredSitesItems);
      setGroupedCards(group);
    }
  }, [filteredSitesItems, groupByExternalId]);

  useEffect(() => {
    groupCards();
  }, [groupCards]);

  const modalInfo = useMountNotificationModal({ sites, enabledEcommercePlusModalToWizard });

  const callFilterCards = useCallback(() => {
    clearTimeout(filterTimeout);
    filterTimeout = setTimeout(() => {
      if (sites.length) {
        const filtered = filterCards(filteredOptions, filterTyped, sites, propagationStatus);
        setFilteredSitesItems(filtered);
      }
    }, 150);
  }, [filteredOptions, filterTyped, sites, filterCards, propagationStatus]);

  useEffect(() => {
    callFilterCards();
  }, [callFilterCards]);

  const handleCloseConfigureDomainModal = useCallback(() => {
    setShouldRenderConfigureDomainModal(false);
  }, []);

  const handleOnCloseWarningModal = useCallback((action) => {
    sitesWarningModalAnalytics.modalWarningClick(modalWarningType, action);
    setShouldRenderNotificationModal(false);
    dispatch(sitesActions.warnings.set());
    const routeWizardWithDomainSelected = `${sitesPagesLocale.routeSitesPages}${sitesPagesLocale.routesNewSite}/${modalDomains}`;

    if (action === modalCloseAction.createSite && modalWarningType === MODAL_TYPE.NEWSITE) {
      history.push(routeWizardWithDomainSelected);
    }

    if (action === modalCloseAction.createSite && modalWarningType === MODAL_TYPE.ECOMMERCEPLUS) {
      history.push(`${routeWizardWithDomainSelected}/ecommerceplus`);
    }
  }, [
    dispatch,
    setShouldRenderNotificationModal,
    modalWarningType,
    history,
    sitesWarningModalAnalytics,
    modalDomains,
  ]);

  const setEmptyOptions = useCallback(() => {
    const options = mountEmptyOptions(products.owned);
    setLinkOptions(options);
  }, [mountEmptyOptions, products.owned]);

  useEffect(() => {
    setEmptyOptions();
  }, [setEmptyOptions]);

  const requestSitesHandlerData = useCallback(() => {
    dispatch(productsActions.products.request({ history: null }));
    dispatch(sitesActions.sites.request());
    dispatch(sitesActions.force.reload(false));
    dispatch(productsActions.products.requestAll());
    dispatch(domainsActions.domains.request({ page: domainsPage }));
    dispatch(sitesActions.allDomainsDnsStatusCheck.request());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const shouldRequestNewDomainsPage = useCallback(() => {
    const hasDomains = domains.list.length > 0;
    const hasMoreDomainsPages = domains.list.length < domains.listTotal;
    const isLoadingDomains = domains.loading;

    if (hasDomains && hasMoreDomainsPages && !isLoadingDomains && !justUpdatedDomains) {
      setDomainsPage(domainsPage + 1);
      setJustUpdatedDomains(true);
    }
  }, [
    domains.loading,
    domains.list,
    domains.listTotal,
    domainsPage,
    justUpdatedDomains,
  ]);

  useEffect(() => {
    shouldRequestNewDomainsPage();
  }, [shouldRequestNewDomainsPage]);

  const requestDomainsPage = useCallback(() => {
    if (justUpdatedDomains) {
      dispatch(domainsActions.domains.request({ page: domainsPage }));
      setJustUpdatedDomains(false);
    }
  }, [domainsPage, dispatch, justUpdatedDomains]);

  useEffect(() => {
    requestDomainsPage();
  }, [requestDomainsPage]);

  useEffect(() => {
    requestSitesHandlerData();
  }, [requestSitesHandlerData]);

  const setModalData = useCallback(() => {
    setModalWarningType(modalInfo.modalType);
    setModalDomains(modalInfo.domainsToShow);
    setShouldRenderNotificationModal(modalInfo.shouldRender);
  }, [modalInfo]);

  useEffect(() => {
    setModalData();
  }, [setModalData]);

  const handleBlockedPopupModalExhibition = useCallback(() => {
    if (popupBlocked) {
      setBlockedPopupOrigin(popupBlocked);
      removePopupBlockedModalFromCookie();
    }
  }, [popupBlocked, removePopupBlockedModalFromCookie]);

  useEffect(() => {
    handleBlockedPopupModalExhibition();
  }, [handleBlockedPopupModalExhibition]);

  const clearBlockedPopupCookieBeforeReload = useCallback(() => {
    const handlePageReload = () => {
      removePopupBlockedModalFromCookie();
    };

    window.addEventListener('beforeunload', handlePageReload);

    return () => {
      window.removeEventListener('beforeunload', handlePageReload);
    };
  }, [removePopupBlockedModalFromCookie]);

  useEffect(() => {
    clearBlockedPopupCookieBeforeReload();
  }, [clearBlockedPopupCookieBeforeReload]);

  useEffect(() => {
    const filteredCanceledSites = filterCanceledSites(sites);
    mountDescription({
      filteredCanceledSites,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sites, mountDescription]);

  useEffect(() => {
    if (clickOnLogoBuilderMenu && buildingLogo) {
      setShowLogoBuilderSuccessModal(true);
      dispatch(logoBuilderActions.clickedOnMenu());
    }
  }, [buildingLogo, clickOnLogoBuilderMenu, dispatch]);

  const setTitanAdvertisementByTestType = (type) => {
    switch (type) {
      case 'toast':
        setShouldRenderToast(true);
        setAdvertisementType('Toast');
        break;
      case 'bottom_banner_dark':
        setShouldRenderBottomBanner(true);
        setAdvertisementType('Banner Dark');
        setBottomBannerVariant('dark');
        break;
      case 'bottom_banner_light':
        setShouldRenderBottomBanner(true);
        setAdvertisementType('Banner Light');
        setBottomBannerVariant('light');
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    setTitanAdvertisementByTestType('top_banner');
  }, []);

  const toolsList = () => {
    const iconsSize = mobile ? 20 : 26;

    return [
      {
        title: sitesPagesLocale.createSiteBanner.tools.wordpress,
        name: 'wordpress',
        icon: <IconDetailedWordpress size={iconsSize} />,
        id: 0,
      },
      {
        title: sitesPagesLocale.createSiteBanner.tools.sitebuilder,
        name: 'sitebuilder',
        icon: <IconDetailedSiteBuilder size={iconsSize} />,
        id: 1,
      },
      {
        title: sitesPagesLocale.createSiteBanner.tools.other,
        name: 'others',
        icon: <IconDetailedOtherSquare width={iconsSize} height={iconsSize} />,
        id: 2,
      },
    ];
  };

  const excludeSiteBuilder = (site) => {
    !loadingExclusion && dispatch(sitesActions.site.delete({ site, setSiteInExclusion }));
  };

  const handleEmptyClick = (option) => {
    sitesHandlerGa({
      gaEventAction: option.label,
      gaEventLabel: '',
    });
  };

  const floatingSurveyProps = () => {
    const defaultProps = {
      onFinishSurvey: handleFinishSurvey,
      shouldRenderOpened: shouldRenderOpened && notShowBannerPopover && !isIframeOpen,
      questionsAnswered: surveyQuestionsAnswered,
      setQuestionsAnswered: setSurveyQuestionsAnswered,
      dispatch: handleSendQuestion,
      handleStartSurvey,
      survey,
      handleClose,
      handleJumpQuestion,
    };
    return { ...defaultProps };
  };

  const titanUpgradeToastHandlerProps = () => {
    const defaultProps = {
      setDisplayModal: setDisplayModalTitanAdvertisementHandler,
    };
    return { ...defaultProps };
  };

  const [subscriptions, setSubscriptions] = useState(null);
  const [invoicesWithSaversDiscount, setInvoicesWithSaversDiscount] = useState([]);

  const verifyDiscountSaversInInvoice = (invoices) => {
    if (invoices !== undefined && invoices.length > 0) {
      const invoicesWithDiscount = invoicesWithSaversDiscount;
      invoices.forEach((invoiceTmp) => {
        if (invoiceTmp.discount !== undefined && invoiceTmp.discount.coupon === DiscountType.SAVERS35OFF) {
          invoicesWithDiscount.push(invoiceTmp);
          setInvoicesWithSaversDiscount(invoicesWithDiscount);
        }
      });
    }
  };

  const verifyDiscountSavers = (invoices) => {
    if (invoices.overdue !== undefined) {
      verifyDiscountSaversInInvoice(invoices.overdue);
    }
    if (invoices.to_due !== undefined) {
      verifyDiscountSaversInInvoice(invoices.to_due);
    }
  };
  useEffect(() => {
    if (diagnostic.invoices !== undefined && invoicesWithSaversDiscount.length === 0) {
      verifyDiscountSavers(diagnostic.invoices);
    }
  }, [diagnostic, diagnostic.invoices]);

  useEffect(() => {
    if (diagnostic.subscriptions !== undefined && diagnostic.subscriptions.to_due !== undefined) {
      setSubscriptions(diagnostic.subscriptions.to_due);
    }
  }, [diagnostic, diagnostic.subscriptions]);


  const [hasMoreThanDiscountSubscription, setHasMoreThanDiscountSubscription] = useState(false);
  const [subscription, setSubscription] = useState(null);

  const getSubscriptionsWithDiscount = () => {
    let totalSubscriptionsWithDescount = 0;

    if (subscriptions !== null) {
      subscriptions.forEach((item) => {
        if (item.discount_enable) {
          setSubscription(item);
          totalSubscriptionsWithDescount += 1;
        }
      });
    }

    setHasMoreThanDiscountSubscription(totalSubscriptionsWithDescount > 1);

    if (totalSubscriptionsWithDescount > 1) {
      setSubscription(null);
    }
  };


  useEffect(() => {
    if (subscriptions !== null && enabledDiscountOfferBanner) {
      getSubscriptionsWithDiscount();
    }
  }, [subscriptions]);

  useEffect(() => {
    if (guideRef && guideRef.current) {
      const { width } = guideRef.current.getBoundingClientRect();

      const leftPosition = guideRef.current.offsetLeft - (width / 2);

      if (guidePosition.left !== leftPosition) {
        setGuidePosition({
          top: guideRef.current.offsetTop, left: leftPosition, width,
        });
      }
    }
  }, [guideRef, guidePosition]);

  const getPageTitleProps = useCallback(() => {
    const headButton = {
      label: sitesLocale.page.createSiteButton,
      buttonVariant: 'primary',
      buttonSize: 'medium2',
      fullWidthHead: true,
      onClick: () => {
        if (button && typeof button.onClick === 'function') {
          button.onClick();
        }
      },
    };

    const defaultProps = {
      testId: 'sites-page-title',
      title: sitesLocale.page.pageTitle,
      headButton: button ? headButton : null,
      hideFilter: true,
    };

    return defaultProps;
  }, [sitesLocale.page, button]);

  const getFilterProps = useCallback(() => {
    const defaultProps = {
      testId: 'filterV2',
      title: '',
      filterLabel: sitesPagesLocale.filter.options.filterBy,
      filterChips: filteredOptions,
      filterByPlaceholder: sitesPagesLocale.filter.searchBarPlaceHolder,
      filterByValue: filterTyped,
      clearFilterLabel: sitesPagesLocale.filter.clear,
      handleClearFilter: clearFilter,
      hideFilter: sites.length < 6,
    };

    const clearOptions = () => {
      try {
        const newOptions = [...filteredOptions].map((option) => {
          const newOption = { ...option };
          newOption.checked = false;
          return newOption;
        });
        return newOptions;
      } catch (e) {
        logger.error('Error on SitesHandler - method clearOptions', e);
      }
    };

    const handleChangeChip = (chip) => {
      try {
        const newOptions = clearOptions();
        const chipIndex = newOptions.findIndex(option => option.id === chip.id);
        if (!chip.checked) {
          newOptions[0].checked = true;
        }

        if (chip.checked) {
          newOptions[chipIndex].checked = true;
        }
        setFilteredOptions(newOptions);
      } catch (e) {
        logger.error('Error on SitesHandler - method handleChangeChip', e);
      }
    };

    const handleChangeFilterBy = (text) => {
      try {
        setFilterTyped(text);
      } catch (e) {
        logger.error('Error on SitesHandler - method handleChangeFilterBy', e);
      }
    };

    return {
      ...defaultProps,
      handleChangeFilterBy,
      handleChangeChip,
    };
  }, [filteredOptions, filterTyped, sites.length, clearFilter, setFilterTyped, setFilteredOptions]);

  const emptyListProps = () => {
    const defaultProps = {
      handleEmptyClick,
      linkOptions,
      emptyLocale: sitesLocale.page.empty,
    };
    return { ...defaultProps };
  };

  const handleCloseAutoSSLModal = () => {
    setDomainToConfigureSSL({ domain: '', hostingId: 0 });
  };


  const trialActiveBannerInSitesProps = () => {
    const defaultProps = {
      domainWithoutEmail,
    };
    return { ...defaultProps };
  };

  const titanUpgradeBottomAdvertisementHandlerProps = () => {
    const defaultProps = {
      variant: bottomBannerVariant,
      setDisplayModal: setDisplayModalTitanAdvertisementHandler,
    };
    return { ...defaultProps };
  };

  const sitesHandlerModalsProps = () => {
    const defaultProps = {
      sitesPagesLocale,
      modalDomains,
      handleOnCloseWarningModal,
      handleCloseConfigureDomainModal,
      shouldRenderNotificationModal,
      shouldRenderConfigureDomainModal,
      modalWarningType,
      enabledNewSiteModal,
      siteInExclusion,
      excludeSiteBuilder,
      setSiteInExclusion,
      loadingExclusion,
      eligibleDomainOptions,
      displayModalTitanAdvertisementHandler,
      setDisplayModalTitanAdvertisementHandler,
      advertisementType,
      showDnsInProgressModal,
      openWordpressLink,
      dnsInProgressDomain,
      ecommercePlusModalAnalytics,
      setShowDnsInProgressModal,
    };

    return { ...defaultProps };
  };

  const getPopoverProps = useCallback(() => ({
    title: sitesLocale.banner.popover.title,
    description: sitesLocale.banner.popover.description,
    buttonLabel: sitesLocale.banner.popover.buttonLabel,
  }), [sitesLocale.banner.popover]);

  const popoverContent = <PopoverContent {...getPopoverProps()} />;

  const highlightSteps = [
    {
      popover: {
        key: 'sitesBannerButton',
        content: popoverContent,
        pointer: 'topRight',
        $maxWidth: 240,
      },
      mask: {
        customRadius: 100,
      },
    },
  ];

  const mountFilter = useCallback((
    <>
      <Styles.Row marginbottom>
        {(displayCreateSiteBanner && onboardingReenterBanner) && (
          <Styles.BannerWrapper>
            {!notShowBannerPopover && <Popover steps={highlightSteps} guideRef={guideRef} storageKey={popoverStorageKey} left={guidePosition.left} />}
            {!showAIAgentButton && (
              <Banner
                title={sitesLocale.banner.title}
                subtitle={sitesLocale.banner.subtitle}
                ctaLabel={sitesLocale.banner.ctaLabel}
                ctaAction={button && button.onClick}
              />
            )}
          </Styles.BannerWrapper>
        )}

        {!showAIAgentButton && (
          <Styles.FilterWrapper>


            <Styles.FilterHeadContainer>
              {(displayCreateSiteBanner && !onboardingReenterBanner) && (
                <Styles.ToolslistWrapper>
                  <Styles.ToolsList>
                    {toolsList().map(tool => (
                      <Styles.Tool key={tool.id}>
                        {tool.icon}
                        <Styles.ToolTitle data-testid={`tool-${tool.name}-title`}>
                          {tool.title}
                        </Styles.ToolTitle>
                      </Styles.Tool>
                    ))}
                  </Styles.ToolsList>
                </Styles.ToolslistWrapper>
              )}
              <Styles.FilterMessage>
                <Styles.Title>{sitesLocale.page.title}</Styles.Title>
                <Styles.Description marginBottom={displayCreateSiteBanner && !onboardingReenterBanner}>
                  {sitesLocale.page.description}
                </Styles.Description>
                {(displayCreateSiteBanner && !onboardingReenterBanner) && <Button label={sitesLocale.page.createNewSiteButton} onClick={button.onClick} />}
              </Styles.FilterMessage>
            </Styles.FilterHeadContainer>
            {filterCanceledSites(sites).length > 5 && (
              <Styles.PageTitleWrapper>

                <PageTitle {...getFilterProps()} noPadding />
              </Styles.PageTitleWrapper>
            )}
          </Styles.FilterWrapper>
        )}
      </Styles.Row>
    </>
  ), [sites, displayCreateSiteBanner, getFilterProps]);


  const getGroupedCardsProps = useCallback(() => {
    const defaultProps = {
      editSiteCta: sitesLocale.page.editSiteCta,
      changeDomainLabel: sitesLocale.page.changeDomain,
      groupedCards,
      propagationStatus,
      propagationAlertLabels: sitesLocale.page.newAlerts.propagation,
      loadingCpanelSSOProductId,
      manageLabel: useCardActionsLocale.manageSite,
      cloudflareLabel: useCardActionsLocale.cloudflareSite,
      tagNewLabel: sitesLocale.page.tagNew,
      getDropdownActions,
      getMainActions,
      loadMoreLabel: sitesLocale.page.seeMoreButton,
      loading: !loadedSites,
      siteTagLabels: sitesLocale.page.tags,
      emptyMessage: sitesLocale.page.emptyState,
      suspendedCpanelTooltip: sitesLocale.page.suspendedCpanelTooltip,
      loadingRedirect,
      changeDomainFlow,
      temporaryDomains: domains.temporaryDomains,
      handleShowTempDomainModal,
      setChangeDomainBlockModal,
    };

    const onChangeDomain = ({ domain, hostingId }) => {
      history.push(`${routes.sitesPage}${routes.changeDomain}/${hostingId}/${domain}`);
    };

    const handlePayInvoice = (id) => {
      try {
        const unpaidInvoicePath = `${routes.invoices}${routes.unpaid}/${id}`;
        history.push(unpaidInvoicePath);
      } catch (e) {
        logger.error('Error on SitesHandler - method handlePayInvoice', e);
      }
    };

    const closerPayment = (financialStatus, siteItem) => {
      try {
        if (financialStatus === STATUS_TYPE.SUSPENDED && siteItem) {
          return siteItem.days_to_cancel_plan >= siteItem.days_to_cancel_domain ? siteItem.days_to_cancel_domain : siteItem.days_to_cancel_plan;
        }
        if (financialStatus === STATUS_TYPE.OVERDUE && siteItem) {
          return siteItem.days_to_suspend_plan >= siteItem.days_to_suspend_domain ? siteItem.days_to_suspend_domain : siteItem.days_to_suspend_plan;
        }
      } catch (e) {
        logger.error('Error on SitesHandler - method closerPayment', e);
      }
    };

    const handleGoToCloudFlare = (group) => {
      const hostingId = group[0].hosting_id;

      history.push(`${routes.products}${routes.cloudflare}/${hostingId}`);
    };

    const handleClickCpanel = (group) => {
      try {
        sitesHandlerGa({
          gaEventAction: 'cPanel',
          gaEventLabel: '',
        });
        if (setBlockedWindowUrl) {
          getURLCpanel({
            externalId: group[0].hosting_id,
            params: null,
            openInNewTab: true,
            dispatch,
            setLoadingCpanelSSOProductId,
            setBlockedWindowUrl,
          });
        }
        setLoadingCpanelSSOProductId(group[0].hosting_id);
      } catch (e) {
        logger.error('Error on SitesHandler - method handleClickCpanel', e);
      }
    };

    const handleManage = (group) => {
      try {
        sitesHandlerGa({
          gaEventAction: 'Gerenciar hospedagem',
          gaEventLabel: '',
        });
        history.push(`${routes.products}${routes.productdetail}/${group[0].hosting_id}`);
      } catch (e) {
        logger.error('Error on SitesHandler - method handleManage', e);
      }
    };

    const hostCount = ({
      group,
    }) => sitesLocale.page.hostCount({
      group,
    });

    const handleEditSite = ({
      domain,
      hostingId,
      builderAddonId,
    }) => {
      const popupBlockedAction = () => {
        setPopupBlockedModalOnCookie({ origin: POPUP_BLOCKED_ORIGIN.OPEN_HG_BUILDER_EDITOR });
      };

      if (setBlockedWindowUrl) {
        dispatch(sitesActions.site.redirectToEdit({
          builderAddonId,
          popupBlockedAction,
          domain,
          hostingId,
          history,
          siteBuilderUrl: domain => `${useCardActionsLocale.routeWebsitebuilderRedirectAccess}/${domain}`,
          sitesWizardUrl: `${routes.sitesPage}${routes.sitesCreate}`,
          webPresenceUrl: `${WHMCS_URL}/index.php?m=webpresence&action=edit&hosting_id=`,
          cpanelUrl: ({ hostingId, softaculous }) => {
            if (softaculous) {
              const url = `${getURLCpanel({ externalId: hostingId })}&app=Softaculous_Home`;
              const newWindow = window.open(url, '_blank');
              if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
                setBlockedWindowUrl(url);
              }
            }

            if (!softaculous) {
              getURLCpanel({
                externalId: hostingId,
                params: softaculous ? '&app=Softaculous_Home' : null,
                openInNewTab: true,
                dispatch,
                setBlockedWindowUrl,
              });
            }
          },
        }));
      }
    };

    return {
      ...defaultProps,
      handleClickCpanel,
      handleManage,
      handlePayInvoice,
      closerPayment: (financialStatus, siteItem) => closerPayment(financialStatus, siteItem),
      hostCount,
      handleEditSite,
      handleGoToCloudFlare,
      onChangeDomain,
    };
  }, [
    loadingRedirect,
    groupedCards,
    dispatch,
    setLoadingCpanelSSOProductId,
    loadingCpanelSSOProductId,
    history,
    routes,
    getDropdownActions,
    getMainActions,
    sitesLocale,
    loadedSites,
    propagationStatus,
    setBlockedWindowUrl,
    changeDomainFlow,
    domains.temporaryDomains,
    setPopupBlockedModalOnCookie,
  ]);

  const handleCloseBlockedWindowModal = useCallback(() => {
    setBlockedWindowUrl(false);
  }, []);

  const getDomainsAlertrsProps = useCallback(() => {
    const defaultProps = {
      diagnostic,
      domains,
    };

    return {
      ...defaultProps,
    };
  }, [
    diagnostic,
    domains,
  ]);

  const bannerProps = useCallback(() => ({
    clickAdvertisingBottom: () => {
      studioAnalytics.bannerAdvertisementBottomPageSites();
    },
  }), []);

  if (!loadedSites || products.listLoading || !products.listLoaded || logoBuilderLoading) {
    return (
      <Styles.Container>
        {mountFilter}

        <Accordion
          width="full"
          justifyContent="flex-start"
          actions={[]}
          open
          onToggleAccordion={() => null}
          leftIcon="IconFile"
          loading
          loadingActionItems={mobile ? 0 : 2}
          loadingTitleWidth="333px"
          loadingListItems={5}
        />
      </Styles.Container>
    );
  }

  const getTypeWelcomeChecklistTypeBanner = () => {
    if (listCheckedsLoaded.length === 0) {
      return 0;
    }
    if (listCheckedsLoaded.length > 0 && listCheckedsLoaded.length < 3) {
      return 1;
    }
    return 2;
  };

  const getWelcomeCheckListBannerProps = () => ({
    open: listCheckedsLoaded.length < 3,
    hostingId,
    listCheckedsLoaded,
    setListCheckedsLoaded,
    originTypeBanner: getTypeWelcomeChecklistTypeBanner(),
    onCloseBanner: e => setAbleSiteToConfigure(e),
    welcomeChecklistBannerAnalytics,
  });

  const getDiscountOfferBannerProps = () => ({
    subscription,
    origin: 'sites',
    hasMoreThanDiscountSubscription,
  });


  const clearTemporayDomainModal = () => {
    setTemporaryDomainModal(null);
    setTemporaryDomainModalOption(null);
  };

  const shouldRenderWelcomeChecklistBanner = enabledWelcomeChecklist && hasAbleSiteToConfigure;
  const shouldRenderDiscountOfferBanner = enabledDiscountOfferBanner && (subscription !== null || hasMoreThanDiscountSubscription);
  const shouldRenderDiscountSaversBanner = enabledDiscountSaversBanner && invoicesWithSaversDiscount.length > 0;
  const shouldRenderLogoBuilderBanner = enableLogoBuilder && logoBuilderAvailable && showLogoBuilder && !viewedLogoBuilderBanner;
  const shouldRenderLogoBuilderModal = buildingLogo && showLogoBuilderSuccessModal;

  return (
    <>
      {temporaryDomainModal && !!temporaryDomainModal.length && (
        <TempDomainModal
          temporaryDomainModal={temporaryDomainModal}
          setTemporaryDomainModal={setTemporaryDomainModal}
          onClose={clearTemporayDomainModal}
          optionLabel={temporaryDomainModalOption}
        />
      )}

      {changeDomainBlockModal && (
        <ChangeDomainBlockModal
          onClose={() => setChangeDomainBlockModal(false)}
        />
      )}

      {(!!blockedWindowUrl) && (
        renderBlockedWindowModal({ url: blockedWindowUrl, closeModal: handleCloseBlockedWindowModal })
      )}

      {shouldRenderSurvey && (
        <Styles.FloatingSurveyContainer>
          <FloatingSurvey {...floatingSurveyProps()} />
        </Styles.FloatingSurveyContainer>
      )}

      <PageMessages displayDomainPropagationAlert />

      <Styles.Container>
        {shouldRenderLogoBuilderBanner && (
          <LogoBuilder
            handleLogoBuilderBanner={handleLogoBuilderBanner}
          />
        )}

        {shouldRenderLogoBuilderModal && (
          <LogoBuilderSuccessModal onClose={() => setShowLogoBuilderSuccessModal(false)} />
        )}

        {shouldRenderWelcomeChecklistBanner && (
          <WelcomeCheckListBanner
            {...getWelcomeCheckListBannerProps()}
          />
        )}

        {shouldRenderDiscountOfferBanner && (
          <DiscountOfferBanner
            {...getDiscountOfferBannerProps()}
          />
        )}

        {shouldRenderDiscountSaversBanner && (
          <DiscountSaversBanner
            invoice={invoicesWithSaversDiscount.length > 1 ? null : invoicesWithSaversDiscount[0]}
          />
        )}

        <Styles.TitleWrapper>
          <PageTitle {...getPageTitleProps()} />
        </Styles.TitleWrapper>

        {mountFilter}

        <DomainsAlerts {...getDomainsAlertrsProps()} />

        {shouldRenderToast && eligibleForTitanUpgrade && (
          <Styles.TitanMessage>
            <TitanUpgradeToastHandler {...titanUpgradeToastHandlerProps()} />
          </Styles.TitanMessage>
        )}

        {filterCanceledSites(sites).length
          ? <GroupedCards {...getGroupedCardsProps()} />
          : <EmptyList {...emptyListProps()} withMessage />
        }

        {domainWithoutEmail.length > 0 && !sites.length && (
          <TrialActiveBannerInSites {...trialActiveBannerInSitesProps()} />
        )}

        {!!blockedPopupOrigin && (
          <ModalBlockedPopup
            onClose={() => setBlockedPopupOrigin(null)}
            origin={blockedPopupOrigin}
          />
        )}

        {!!domainToConfigureSSL.hostingId && (
          <ModalAutoSSL
            handleCloseModal={handleCloseAutoSSLModal}
            domainToConfigureSSL={domainToConfigureSSL}
            initialStep={sslModalInitialStep}
          />
        )}

        <Styles.Row>
          <Styles.FaqWrapper>
            <FaqMySites />
            {shouldRenderBottomBanner && eligibleForTitanUpgrade && <TitanUpgradeBottomAdvertisementHandler {...titanUpgradeBottomAdvertisementHandlerProps()} />}

            <StudioAdBanner position="bottom" {...bannerProps()} />
          </Styles.FaqWrapper>
        </Styles.Row>

        <SitesHandlerModals {...sitesHandlerModalsProps()} />
      </Styles.Container>
    </>
  );
};

export default withI18n()(SitesHandler);
